import React from "react";
import Dispatcher from "../../../dispatcher";
import HighlightAction from "../../../actions/highlight-action";
import MarkerAction from "../../../actions/marker-action";
import BookStore from "../../../stores/book-store";
import MarkerStore from "../../../stores/marker-store";
import HighlightStore from "../../../stores/highlight-store";
import Speaker from "../tts/speaker";
import { isEmojiMarker } from "./../highlights/emoji-reactions/helpers";

var Isvg = require("../../../../vendor/react-inlinesvg");
var Menu = require("../../ui_elements/menu").Menu;
var MenuMixin = require("../../ui_elements/menu").MenuMixin;
var MenuHeader = require("../../ui_elements/menu-header");
var EditNoteContainer = require("./edit-note-container");
import DeckList from "../highlights/deck-list";
import gadgets from "../../gadgets/gadgets";

class MobileHighlightContainer extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      visible: false,
      animate: 0.0,
      currentMarker: null
    };

    // MenuMixin bindings
    this._toggleMenu = MenuMixin._toggleMenu.bind(this);
    this._showMenu = MenuMixin._showMenu.bind(this);
    this._removeMenu = MenuMixin._removeMenu.bind(this);
    this._redrawMenu = MenuMixin._redrawMenu.bind(this);

    // Method bindings
    this._close = this._close.bind(this);
    this._shouldShow = this._shouldShow.bind(this);
    this._highlightClick = this._highlightClick.bind(this);
    this._noteIconClick = this._noteIconClick.bind(this);
    this._markersChanged = this._markersChanged.bind(this);
    this._highlightsChanged = this._highlightsChanged.bind(this);
    this._selectionMade = this._selectionMade.bind(this);
    this._selectionCancelled = this._selectionCancelled.bind(this);
    this._addHighlight = this._addHighlight.bind(this);
    this._clickDeleteHighlight = this._clickDeleteHighlight.bind(this);
    this._deleteHighlight = this._deleteHighlight.bind(this);
    this._showMobileColorMenu = this._showMobileColorMenu.bind(this);
    this._changeMarker = this._changeMarker.bind(this);
    this._noteButton = this._noteButton.bind(this);
    this._onMobileNoteOpen = this._onMobileNoteOpen.bind(this);
    this._onMobileNoteCancel = this._onMobileNoteCancel.bind(this);
    this._onMobileNoteSave = this._onMobileNoteSave.bind(this);
    this._copyHighlight = this._copyHighlight.bind(this);
    this._getMarkerDots = this._getMarkerDots.bind(this);
  }

  componentDidMount() {
    Dispatcher.setMaxListeners(Dispatcher.getMaxListeners() + 7);
    Dispatcher.bind(
      Dispatcher.BOOK_SELECTION_WITH_POSITION,
      this._selectionMade
    );
    Dispatcher.bind(
      Dispatcher.BOOK_SELECTION_CANCELLED,
      this._selectionCancelled
    );
    Dispatcher.bind(Dispatcher.BOOK_CLICK, this._selectionCancelled);
    Dispatcher.bind(Dispatcher.BOOK_HIGHLIGHT_CLICK, this._highlightClick);
    Dispatcher.bind(Dispatcher.HIGHLIGHTS_CHANGE, this._highlightsChanged);
    Dispatcher.bind(Dispatcher.MARKERS_CHANGE, this._markersChanged);
    Dispatcher.bind(Dispatcher.BOOK_NOTEICON_CLICK, this._noteIconClick);
  }

  componentWillUnmount() {
    Dispatcher.unbind(
      Dispatcher.BOOK_SELECTION_WITH_POSITION,
      this._selectionMade
    );
    Dispatcher.unbind(
      Dispatcher.BOOK_SELECTION_CANCELLED,
      this._selectionCancelled
    );
    Dispatcher.unbind(Dispatcher.BOOK_CLICK, this._selectionCancelled);
    Dispatcher.unbind(Dispatcher.BOOK_HIGHLIGHT_CLICK, this._highlightClick);
    Dispatcher.unbind(Dispatcher.HIGHLIGHTS_CHANGE, this._highlightsChanged);
    Dispatcher.unbind(Dispatcher.MARKERS_CHANGE, this._markersChanged);
    Dispatcher.unbind(Dispatcher.BOOK_NOTEICON_CLICK, this._noteIconClick);
    Dispatcher.setMaxListeners(Dispatcher.getMaxListeners() - 7);
  }

  componentDidUpdate() {
    if (this.state.animate < 1.0 && this.state.visible) {
      setTimeout(() => {
        this.setState({ animate: Math.min(1.0, this.state.animate + 0.1) });
      }, 5);
    }
  }

  _close(isbn) {
    this.setState({
      visible: false,
      isbn: isbn,
      syncId: false,
      selectedText: false,
      currentHighlight: false,
      ignoreSelectionCancelled: false,
      bottom: false,
      animate: 0.0
    });
  }

  _shouldShow(isbn) {
    const book = BookStore.get(isbn);
    return !(
      !Fraction.Helpers.isTouchDevice() ||
      (!Fraction.Brand.Reader.mobilePbkHighlighting &&
        (book.vbkType === "pbk" || book.vbkType === "pdf")) ||
      (!Fraction.Brand.Reader.mobileEpubHighlighting &&
        book.vbkType === "epub") ||
      (!Fraction.Brand.Reader.mobileDashHighlighting && book.vbkType === "dash")
    );
  }

  _highlightClick(isbn, e, data) {
    if (this._shouldShow(isbn)) {
      const currentHighlight = HighlightStore.get(isbn, data.syncId);
      MarkerAction.setCurrentMarker(MarkerStore.get(currentHighlight.markerId));
      this.setState({
        visible: true,
        isbn: isbn,
        syncId: data.syncId,
        ignoreSelectionCancelled: true,
        currentHighlight: currentHighlight
      });
      // because of potential delay on touch events, selectionCancelled could fire as far as 250ms behind of this function
      setTimeout(() => {
        this.setState({ ignoreSelectionCancelled: false });
      }, 1250);
    }
  }

  _noteIconClick(isbn, e, data) {
    if (this._shouldShow(isbn)) {
      this._highlightClick(isbn, e, data);
      if (!isEmojiMarker(this.state.currentMarker)) {
        this._noteButton();
      }
    }
  }

  _markersChanged() {
    this.setState({
      currentMarker: MarkerStore.getCurrentMarker(),
      markers: MarkerStore.getAll()
    });
  }

  _highlightsChanged(isbn) {
    this._close();
  }

  _selectionMade(isbn, e, data) {
    if (this._shouldShow(isbn)) {
      const bottom = data.selectionRect.top < window.innerHeight / 2;
      if (this.state.syncId) {
        this._close();
      }
      this.setState({
        visible: true,
        isbn: isbn,
        syncId: false,
        currentHighlight: false,
        selectedText: data.selectedText,
        bottom: bottom
      });
    }
  }

  _selectionCancelled(isbn, e, data) {
    if (!this.state.ignoreSelectionCancelled) {
      this._close();
    }
  }

  _addHighlight(e) {
    e.preventDefault();
    HighlightAction.addHighlight(this.state.isbn);
  }

  _clickDeleteHighlight(e) {
    e.preventDefault();
    if (this.state.currentHighlight.hasNote) {
      Fraction.Helpers.showModal(
        {
          title: i18n.t("reader.notebook.note-associated-title"),
          content: (
            <span>{i18n.t("reader.notebook.note-associated-text")}</span>
          ),
          buttons: [
            {
              label: i18n.t("base.cancel"),
              click: Fraction.Helpers.removeModal,
              color: "gray"
            },
            {
              label: i18n.t("base.delete"),
              click: this._deleteHighlight
            }
          ]
        },
        $(e.currentTarget)
      );
    } else {
      this._deleteHighlight();
    }
  }

  _deleteHighlight() {
    HighlightAction.deleteHighlight(this.state.isbn, this.state.syncId);
    Fraction.Helpers.removeModal();
  }

  _showMobileColorMenu(e) {
    this._toggleMenu(e);
  }

  _changeMarker(e) {
    e.preventDefault();
    const currentMarker = MarkerStore.getCurrentMarker();
    const marker = MarkerStore.get($(e.currentTarget).data("markerid"));
    if (currentMarker.globalId === marker.globalId) {
      Fraction.Reporter.gaEvent(
        "V3/highlights",
        "click",
        "clickSameNewHighlightColor"
      );
    } else {
      Fraction.Reporter.gaEvent(
        "V3/highlights",
        "click",
        "changeNewHighlightColor"
      );
    }
    MarkerAction.setCurrentMarker(marker);
    if (this.state.syncId) {
      // TODO highlight with this marker! update it
      HighlightAction.updateHighlight(this.state.isbn, this.state.syncId, {
        markerId: marker.globalId
      });
      this._removeMenu("mobile-highlight-color-menu");
      this._close();
      return;
    }
  }

  _noteButton(e) {
    if (e) {
      e.preventDefault();
    }
    Fraction.Helpers.showModal({
      title: false,
      content: (
        <EditNoteContainer
          markerLabel={this.state.currentMarker.label}
          lastModifiedString={
            this.state.currentHighlight
              ? this.state.currentHighlight.lastModifiedString
              : ""
          }
          highlightColor={this.state.currentMarker.vstColor}
          highlightText={
            this.state.currentHighlight
              ? this.state.currentHighlight.selectedText
              : this.state.selectedText
          }
          noteText={
            this.state.currentHighlight
              ? this.state.currentHighlight.noteText
              : ""
          }
          openCallback={this._onMobileNoteOpen}
          cancelCallback={this._onMobileNoteCancel}
          saveCallback={this._onMobileNoteSave}
        />
      ),
      buttons: [],
      fullscreen: true,
      intersitial: true
    });
  }

  _onMobileNoteOpen() {}

  _onMobileNoteCancel() {
    this._close();
  }

  _onMobileNoteSave(noteText) {
    if (this.state.currentHighlight) {
      HighlightAction.updateHighlight(this.state.isbn, this.state.syncId, {
        noteText: noteText
      });
    } else {
      // create a new highlight with note text
      HighlightAction.addHighlight(this.state.isbn, noteText);
    }
    this._close();
  }

  _copyHighlight(e) {
    let textToCopy = this.state.selectedText;
    if (this.state.syncId) {
      const currentHighlight = HighlightStore.get(
        this.state.isbn,
        this.state.syncId
      );
      textToCopy = currentHighlight.selectedText;
    }
    if (Fraction.Helpers.copyText(textToCopy)) {
      Fraction.Reporter.gaEvent("reader/highlights/popup/copy");
      if (this.state.currentHighlight) {
        Fraction.Helpers.toast(i18n.t("highlighters.highlight-copied"));
      } else {
        Fraction.Helpers.toast(i18n.t("highlighters.selection-copied"));
      }
    } else {
      Fraction.Helpers.toast(i18n.t("highlighters.could-not-copy"));
    }
    this._removeMenu();
  }

  _getMarkerDots() {
    let currentMarkerId = this.state.currentMarker.globalId;
    let allMarkers = MarkerStore.getAll().markers;
    return allMarkers.map(marker => {
      let markerStyle = { background: marker.color, outline: 0 };
      let selectedClass = "";
      markerStyle.borderColor = marker.darkColor;
      if (currentMarkerId === marker.globalId) {
        selectedClass = "selected";
      }
      return (
        <button
          key={"marker-button-" + marker.darkColor + "-" + marker.globalId}
          className={"noButton marker " + selectedClass}
          onMouseOver={this._hoverOverMarker}
          onMouseOut={this._hoverOutMarker}
          style={markerStyle}
          data-markerid={marker.globalId}
          data-selectcolor={marker.darkColor}
          onClick={this._changeMarker}
          onTouchEnd={this._changeMarker}
        >
          {marker.shared && (
            <Isvg
              style={{ color: marker.darkColor }}
              src="../../../img/public_icon.svg"
            />
          )}
        </button>
      );
    });
  }

  render() {
    const book = BookStore.get(this.state.isbn);
    if (this.state.visible) {
      let buttonStyle = {
        background: this.state.currentMarker.vstColorDark,
        width: this.state.animate * 44,
        height: this.state.animate * 44,
        marginRight: 14 + (22.0 * (1.0 - this.state.animate)) / 2.0
      };
      let colorMenu = (
        <span>
          <button
            className="container-button"
            data-menu-id="mobile-highlight-color-menu"
            onClick={this._showMobileColorMenu}
            onTouchEnd={this._showMobileColorMenu}
            aria-expanded="false"
            style={buttonStyle}
          >
            <Isvg src="/img/highlight_color.svg">NS</Isvg>
          </button>
          <Menu
            id="mobile-highlight-color-menu"
            key="mobile-highlight-color-menu"
            menuId="mobile-highlight-color-menu"
            direction="right"
            hideCover={true}
            yOffset={-53}
            xOffset={-10}
          >
            <MenuHeader>{this.state.currentMarker.label}</MenuHeader>
            <div className="marker-select-list">
              <span />
              {this._getMarkerDots()}
            </div>
          </Menu>
        </span>
      );
      let flashcardsMenu = (
        <span>
          <button
            className="container-button"
            data-menu-id="flashcards-menu"
            onClick={this._toggleMenu}
            onTouchEnd={this._toggleMenu}
            aria-expanded="false"
            style={buttonStyle}
          >
            <Isvg src="/img/add_flashcard.svg">NS</Isvg>
          </button>
          <Menu
            id="flashcards-menu"
            key="flashcards-menu"
            menuId="flashcards-menu"
            direction="right"
            hideCover={true}
            yOffset={this.state.bottom ? 60 : -100}
            xOffset={-10}
          >
            <div className="marker-select-list">
              <span />
              <DeckList
                isbn={this.state.isbn}
                selectedText={this.state.selectedText}
                closePopover={() => this._removeMenu("flashcards-menu")}
              />
            </div>
          </Menu>
        </span>
      );
      let copyButton = (
        <button
          className="container-button"
          style={buttonStyle}
          onClick={this._copyHighlight}
          onTouchEnd={this._copyHighlight}
        >
          <Isvg src="/img/copy_circle.svg">
            <span className="offScreen">{i18n.t("notebook.copy")}</span>
          </Isvg>
        </button>
      );
      const ttsButton = (
        <button
          className="container-button"
          style={buttonStyle}
          onClick={() => {
            book.viewer.TTS.startFromSelection();
            Dispatcher.emit(Dispatcher.TTS_OPEN);
          }}
        >
          <Speaker />
        </button>
      );
      let containerStyle = { opacity: this.state.animate };
      if (this.state.bottom) {
        containerStyle = { top: "auto", bottom: 92 };
      }
      if (this.state.syncId) {
        // a highlight has been selected (not new)
        const emojiNote = isEmojiMarker(this.state.currentMarker);
        return (
          <div className="mobile-highlight-container" style={containerStyle}>
            {!this.state.currentHighlight.shared && !emojiNote && colorMenu}
            {(!this.state.currentHighlight.shared ||
              this.state.currentHighlight.hasNote) &&
              !emojiNote && (
                <button
                  className="container-button"
                  style={buttonStyle}
                  onClick={this._noteButton}
                  onTouchEnd={this._noteButton}
                >
                  <Isvg
                    src={
                      this.state.currentHighlight.hasNote
                        ? "/img/note.svg"
                        : "/img/add_note.svg"
                    }
                  >
                    <span className="offScreen">
                      {i18n.t("notebook.add-note")}
                    </span>
                  </Isvg>
                </button>
              )}
            {!this.state.currentHighlight.shared && (
              <button
                className="container-button"
                style={buttonStyle}
                onClick={this._clickDeleteHighlight}
                onTouchEnd={this._clickDeleteHighlight}
              >
                <Isvg src="/img/highlight_trash.svg">
                  <span className="offScreen">
                    {i18n.t("notebook.delete-highlight")}
                  </span>
                </Isvg>
              </button>
            )}
            {!this.state.currentHighlight.shared &&
              Fraction.Helpers.copyEnabled() &&
              copyButton}
          </div>
        );
      } else {
        // new selection
        let gadget = gadgets.find(
          gadget => gadget.metadata().id === "flashcards"
        );
        return (
          <div className="mobile-highlight-container" style={containerStyle}>
            {!this.state.currentHighlight.shared && colorMenu}
            {!this.state.currentHighlight.shared && (
              <button
                className="container-button"
                style={buttonStyle}
                onClick={this._addHighlight}
                onTouchEnd={this._addHighlight}
              >
                <Isvg src="/img/highlighter.svg">
                  <span className="offScreen">
                    {i18n.t("notebook.add-highlight")}
                  </span>
                </Isvg>
              </button>
            )}
            {!this.state.currentHighlight.shared && (
              <button
                className="container-button"
                style={buttonStyle}
                onClick={this._noteButton}
                onTouchEnd={this._noteButton}
              >
                <Isvg src="/img/add_note.svg">
                  <span className="offscreen">
                    {i18n.t("notebook.add-note")}
                  </span>
                </Isvg>
              </button>
            )}
            {!this.state.currentHighlight.shared &&
              Fraction.Helpers.copyEnabled() &&
              copyButton}
            {!this.state.currentHighlight.shared &&
              gadget.metadata().enabled() &&
              flashcardsMenu}
            {window.hasOwnProperty("speechSynthesis") &&
              Fraction.Brand.TTS.enabled &&
              ttsButton}
          </div>
        );
      }
    } else {
      return <span />;
    }
  }
}

module.exports = MobileHighlightContainer;
